import { createContext, useContext } from 'react'
import type { LucideIcon } from 'lucide-react'

/** The sidebar destination the current route belongs to (label + icon). */
export type PageSection = { label: string; icon: LucideIcon }

export const PageSectionContext = createContext<PageSection | null>(null)

export function usePageSection(): PageSection | null {
  return useContext(PageSectionContext)
}
